
import { ROUTE_LOGISTICA } from '../constants/constant.model';
import { ApiService } from './api.service';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { iGuiaInterna } from '../models/iGuiaInterna.model';

@Injectable({
    providedIn: 'root'
})
export class GuiaInternaService {


    constructor(
        private apiService: ApiService,
        private http: HttpClient
    ) { }

    insertarGuiaInterna(data: iGuiaInterna): Observable<any> {
        this.apiService.setUrlPathApi(ROUTE_LOGISTICA.crudGuiaInterna);
        return this.apiService.executePostJson(data).pipe();
    }

    actualizarGuiaInterna(data: iGuiaInterna) {
        this.apiService.setUrlPathApi(ROUTE_LOGISTICA.crudGuiaInterna + '/costeo-importacion');
        return this.apiService.executePutJson(data).pipe();
    }

    calcularGuiaInterna(data: iGuiaInterna): Observable<any> {
        this.apiService.setUrlPathApi(ROUTE_LOGISTICA.calcularGuiaInterna);
        return this.apiService.executePutJson(data).pipe();
    }

    buscar(fdesde: string, fhasta: string, codcli: string, codven: number, codsuc: number, situac: string, lugemi: number, limit: number, offset: number): Observable<any> {
        this.apiService.setUrlPathApi(ROUTE_LOGISTICA.buscarGuiaInterna);
        return this.apiService.execGetQueryJson(`?fdesde=${fdesde}&fhasta=${fhasta}&codcli=${codcli}&codven=${codven}&codsuc=${codsuc}&situac=${situac}&lugemi=${lugemi}&limit=${limit}&offset=${offset}`).pipe();
    }

    download_pdf(_formato: number, numint: number, cia: string) {
        let fullUrl: any = null;
        if (_formato == 1)
            fullUrl = environment.serviceUrl_Report + `guia-interna/${numint}/report/public/format-1.pdf?` + "cia=" + cia;
        if (_formato == 2)
            fullUrl = environment.serviceUrl_Report + `guia-interna/${numint}/report/public/format-2.pdf?` + "cia=" + cia;
        const httpOptions = {
            'responseType': 'arraybuffer' as 'json'
        };
        return this.http.get(fullUrl, httpOptions);
    }

    download_guia_costeo(_formato: number, numint: number, cia: string) {
        let fullUrl: any = null;
        if (_formato == 1)
            fullUrl = environment.serviceUrl + `guia-interna/${numint}/report/public/format-H.pdf?` + "cia=" + cia;
        const httpOptions = {
            'responseType': 'arraybuffer' as 'json'
        };
        return this.http.get(fullUrl, httpOptions);
    }


    reutilizarGuiaInterna(serie: number, numdoc: number) {
        this.apiService.setUrlPathApi(ROUTE_LOGISTICA.crudGuiaInterna);
        return this.apiService.execGetQueryJson(`/${serie}/${numdoc}`).pipe();
    }

    listOrdenCompraPendientes(femisi: string, moneda: string, codsuc: number, codcli: string, destin: number): Observable<any> {
        this.apiService.setUrlPathApi('orden-compra/buscar/pendientes-aprobados');
        return this.apiService.execGetQueryJson(`?femisi=${femisi}&moneda=${moneda}&codsuc=${codsuc}&codcli=${codcli}&destin=${destin}`).pipe();
    }

    listOrdenCompraPendientes2(femisi: string, moneda: string, codsuc: number, codcli: String): Observable<any> {
        this.apiService.setUrlPathApi('orden-compra/buscar/pendientes-aprobados');
        return this.apiService.execGetQueryJson(`?femisi=${femisi}&moneda=${moneda}&codsuc=${codsuc}&codcli=${codcli}`).pipe();
    }

    listOrdenCompraPendientesImportacion(femisi: string, moneda: string, codsuc: number, codcli: String): Observable<any> {
        this.apiService.setUrlPathApi('importacion-orden-compra/buscar/pendientes-aprobados');
        return this.apiService.execGetQueryJson(`?femisi=${femisi}&moneda=${moneda}&codsuc=${codsuc}&codcli=${codcli}`).pipe();
    }

    listDocImportPendientes(femisi: string, moneda: string, codsuc: number, codcli: string): Observable<any> {
        this.apiService.setUrlPathApi('documento-importacion/buscar/pendientes-aprobados');
        return this.apiService.execGetQueryJson(`?femisi=${femisi}&moneda=${moneda}&codsuc=${codsuc}&codcli=${codcli}`).pipe();
    }

    public anular(numint: number, coduser: string) {
        return this.http.put(environment.serviceUrl + "guia-interna/" + numint + "/anular", null, { observe: 'response' },)
    }

    downloadExcelComercialResportesGuiaInterna(fdesde: string, fhasta: string, codcli: string, codven: number, codsuc: number, situac: string, lugemi: number, limit: number, offset: number): Observable<any> {
        this.apiService.setUrlPathApi('consultas/guia-interna');
        return this.apiService.execGetQueryJsonPDF(`/excel.xlsx?fdesde=${fdesde}&fhasta=${fhasta}&codcli=${codcli}&codven=${codven}&codsuc=${codsuc}&situac=${situac}&lugemi=${lugemi}&limit=${limit}&offset=${offset}`).pipe();
    }

    buscarGuiaInterna(fdesde: string, fhasta: string, codcli: string, codven: number, codsuc: number, situac: string, lugemi: number, limit: number, offset: number, id: any, codmot: any): Observable<any> {
        this.apiService.setUrlPathApi(ROUTE_LOGISTICA.buscarGuiaInterna);
        return this.apiService.execGetQueryJson(`?fdesde=${fdesde}&fhasta=${fhasta}&codcli=${codcli}&codven=${codven}&codsuc=${codsuc}&situac=${situac}&lugemi=${lugemi}&limit=${limit}&offset=${offset}&id=${id}&codmot=${codmot}`).pipe();
    }

    buscarPendientes(femisi : any , moneda : string , codmot : number , codsuc : string, codcli : string, id : any): Observable<any> {
        this.apiService.setUrlPathApi(ROUTE_LOGISTICA.buscarGuiaInterna+'/rel-doc-pendientes');
        return this.apiService.execGetQueryJson(`?femisi=${femisi}&moneda=${moneda}&codmot=${codmot}&codsuc=${codsuc}&codcli=${codcli}`).pipe();
    }
    obtenerGuia(numint: number): Observable<any> {
        return this.http.get(environment.serviceUrl + "guia-interna/" + numint, { observe: 'response' })
      }
    
      buscar2(fdesde: string, fhasta: string, codcli: string, codven: number, codsuc: number, situac: string, lugemi: number, limit: number, offset: number, id: string, codmot: number): Observable<any> {
        this.apiService.setUrlPathApi(ROUTE_LOGISTICA.buscarGuiaInterna);
        return this.apiService.execGetQueryJson(`?fdesde=${fdesde}&fhasta=${fhasta}&codcli=${codcli}&codven=${codven}&codsuc=${codsuc}&situac=${situac}&lugemi=${lugemi}&limit=${limit}&offset=${offset}&id=${id}&codmot=${codmot}`).pipe();
    }
     enviarKardex(numint:any){
        this.apiService.setUrlPathApi(`guia-interna/${numint}/enviar-kardex`);
        return this.apiService.executePutJson('').pipe();
     }
}
